"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePolicyApi = void 0;
var next_api_swr_1 = require("@newfront-insurance/next-api-swr");
var routes_1 = require("../bff/routes");
var provider_1 = require("../provider");
function usePolicyApi() {
    var fetch = next_api_swr_1.useNextApiFetch();
    var basePath = provider_1.useCoverageApiBasePath();
    return {
        createHistoricalPolicy: function (body) {
            return fetch({
                url: withBasePath(basePath, routes_1.routes.createHistoricalPolicy.getUrl({})),
                method: 'POST',
                body: body,
            });
        },
        updateNotes: function (params, body) {
            return fetch({
                url: withBasePath(basePath, routes_1.routes.updatePolicyNotes.getUrl({ policyUuid: params.policyUuid })),
                method: 'PUT',
                body: body,
            });
        },
        updateLinesOfCoverage: function (params, body) {
            return fetch({
                url: withBasePath(basePath, routes_1.routes.updatePolicyLinesOfCoverage.getUrl({ policyUuid: params.policyUuid })),
                method: 'PUT',
                body: body,
            });
        },
        updateBilling: function (params, body) {
            return fetch({
                method: 'PUT',
                url: withBasePath(basePath, routes_1.routes.updatePolicyBilling.getUrl({ policyUuid: params.policyUuid })),
                body: body,
            });
        },
        updateDetails: function (params, body) {
            return fetch({
                method: 'PUT',
                url: withBasePath(basePath, routes_1.routes.updatePolicyDetails.getUrl({ policyUuid: params.policyUuid })),
                body: body,
            });
        },
        updateDateRange: function (params, body) {
            return fetch({
                method: 'PUT',
                url: withBasePath(basePath, routes_1.routes.updatePolicyDateRange.getUrl({ policyUuid: params.policyUuid })),
                body: body,
            });
        },
        renewAsIs: function (body) {
            return fetch({
                method: 'POST',
                url: withBasePath(basePath, routes_1.routes.renewPolicyAsIs.getUrl({})),
                body: body,
            });
        },
    };
}
exports.usePolicyApi = usePolicyApi;
function withBasePath(basePath, url) {
    return "" + basePath + url;
}
